<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <component :is="cardType" class="image-card" v-bind="{ ...propTypes}">
      <div class="image">
        <ShImage class="img" :src="setImageSrc" :alt="imageAlt"/>
      </div>

      <heading class="title" :tagField="innerHeadingSize" :textField="venueName"/>

      <div class="subtitle">{{location}}</div>

      <div class="description">{{description}}</div>
    </component>
  </sc-render>
</template>

<script>
import { ShImage } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'

import ShLink from '~/components/sh-link'
import get from '~/helpers/get'

import ScRender from '../sc-render'
import Heading from '../heading'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'AutomatedContentListTile',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },

    innerHeadingSize: {
      type: Object,
      required: true
    }
  },

  components: {
    ScRender,
    ShImage,
    Heading,
    ShLink
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    imageFields () {
      return get(this.fields, 'houseImage')
    },

    imageAlt () {
      return get(this.imageFields, 'value.alt')
    },

    setImageSrc () {
      return get(this.imageFields, 'value.src')
    },

    venueName () {
      return get(this.fields, 'venueName')
    },

    location () {
      return get(this.fields, 'location.value')
    },

    description () {
      return get(this.fields, 'description.value')
    },

    linkHref () {
      return get(this.fields, 'link.value.href')
    },

    linkTarget () {
      return get(this.fields, 'link.value.linktarget', '')
    },

    cardType () {
      if (!this.linkHref) return 'div'

      return 'sh-link'
    },

    propTypes () {
      if (this.cardType === 'div') {
        return { tabindex: '0' }
      }

      return {
        to: this.linkHref,
        target: this.linkTarget
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-card {
  display: flex;
  flex-direction: column;
  padding: 0 $space-020;
  width: 265px;
  flex-shrink: 0;
  text-decoration: none;
  @include tablet {
    width: 25%;
    max-width: 600px;
    flex-shrink: 1;
    margin-bottom: $space-090;
  }

  .image {
    position: relative;
    width: 100%;
    // Use the padding to force the aspect ratio
    padding-top: 100%;
    margin-bottom: $space-040;

    img {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}

.title {
  @include font('070');
  margin-bottom: $space-020;
}

.subtitle {
  @include font('040');
  margin-bottom: $space-020;
}

.description {
  @include font('040');
  color: $color_gray;
}
</style>
